import { useQuery } from '@tanstack/react-query';
import { API_URL } from '../config/api';
import { authFetch } from '../utils/authFetch';

export interface Disbursement {
  id: number;
  rule: number;
  week_start: string;
  amount: string;
  status: string;
  ruleDetails?: {
    category: string;
    percentage: number;
  };
}

export function useCurrentWeekDisbursements() {
  return useQuery<Disbursement[]>({
    queryKey: ['currentWeekDisbursements'],
    queryFn: async () => {
      const response = await authFetch(`${API_URL}/disbursements/`);
      if (!response.ok) throw new Error('Failed to fetch disbursements');
      return response.json();
    },
  });
} 